import { useEffect, useState } from "react";
import axios from "axios";
import { Dumbbell } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";
const API = `${BACKEND_URL}/api`;
const DEFAULT_BRAND = {
  brand_name: "FitPulse Pro",
  logo_path: null,
};

function resolveMediaUrl(path) {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  return `${BACKEND_URL}${path.startsWith("/") ? path : `/${path}`}`;
}

export function BrandLogo({
  size = "md",
  showText = true,
  subtitle = "Admin Dashboard",
  textClassName = "",
}) {
  const { user } = useAuth();
  const [brand, setBrand] = useState(DEFAULT_BRAND);

  useEffect(() => {
    let cancelled = false;

    const fetchBrand = async () => {
      try {
        const { data } = await axios.get(`${API}/public/site-content`, { timeout: 8000 });
        if (!cancelled && data && typeof data === "object") {
          setBrand({ ...DEFAULT_BRAND, ...data });
        }
      } catch (_) {
        if (!cancelled) {
          setBrand(DEFAULT_BRAND);
        }
      }
    };

    fetchBrand();
    return () => {
      cancelled = true;
    };
  }, []);

  const isCompact = size === "sm";
  const logoHeightClass = isCompact ? "h-10 max-w-[180px]" : "h-16 max-w-[240px]";
  const iconBoxClass = isCompact ? "h-10 w-10" : "h-16 w-16";
  const iconClass = isCompact ? "h-5 w-5" : "h-8 w-8";
  const titleClass = isCompact ? "text-lg" : "text-3xl";
  const subtitleClass = isCompact ? "text-[11px]" : "text-sm";
  const merchantLogoPath = String(user?.merchant_logo_path || "").trim();
  const activeBrand = merchantLogoPath
    ? {
        ...brand,
        brand_name: user?.merchant_name || brand.brand_name,
        logo_path: merchantLogoPath,
      }
    : brand;

  return (
    <div className="flex items-center gap-3">
      {activeBrand.logo_path ? (
        <img
          src={resolveMediaUrl(activeBrand.logo_path)}
          alt={activeBrand.brand_name}
          className={`block w-auto shrink-0 object-contain object-left align-middle drop-shadow-[0_0_18px_rgba(212,175,55,0.14)] ${logoHeightClass}`}
        />
      ) : (
        <div className={`flex items-center justify-center rounded-sm bg-[#D4AF37] text-black shadow-[0_10px_30px_rgba(212,175,55,0.18)] ${iconBoxClass}`}>
          <Dumbbell className={iconClass} strokeWidth={2.4} />
        </div>
      )}

      {showText && !activeBrand.logo_path && (
        <div className={textClassName}>
          <h1 className={`${titleClass} font-bold tracking-tight text-white`}>{activeBrand.brand_name}</h1>
          <p className={`${subtitleClass} mt-1 text-zinc-500`}>{subtitle}</p>
        </div>
      )}
    </div>
  );
}
